// Privacy-safe analytics helpers. Reuses the PostHog client already loaded in
// public/index.html. No PII (names, emails, report content, user/Stripe IDs) is
// ever sent. PostHog's built-in opt-out is respected by posthog.capture itself.

export const PLAN_VALUE = { prove: 29, build: 69, launch: 149, grow: 299, scale: 499 };

export function track(event, props = {}) {
  try {
    const ph = typeof window !== "undefined" ? window.posthog : null;
    if (ph && typeof ph.capture === "function") {
      const clean = Object.fromEntries(Object.entries(props).filter(([, v]) => v != null));
      ph.capture(event, clean);
    }
  } catch {
    /* never break UX for analytics */
  }
}
